import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
   id: null,
   activeConversationChannel: {},
};

const channelNavSlice = createSlice({
   name: 'channelNavData',
   initialState,
   reducers: {
      setActiveConversationChannel(state, action) {
         state.activeConversationChannel = action.payload;
      },
      retActiveConversationChannel() {
         return { ...initialState };
      },
   },
   extraReducers: builder => {
      builder.addCase(clearState, () => initialState);
   },
});

export const { setActiveConversationChannel, retActiveConversationChannel } = channelNavSlice.actions;
export default channelNavSlice.reducer;
